import { Box, Typography } from "@mui/material";

import { Toggle } from "../../../../../common/components/Toggle";
import { textNeutralSecondary } from "../../../../../core/theme";
import { AdjustmentsFrequency, ComputationFrequency } from "../../../../../requests_cm/gecoContractsService/types";
import FluidSelect from "../../../../../common/components/FluidSelect";


const style = {
	container: {
		width: 162,
	},
	wrapper: {
		display: "flex",
		flexDirection: "row",
		gap: "16px",
		flexWrap: "wrap",
	},
    toogleBox: {
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
    },
    title: {
        color: textNeutralSecondary,
        fontSize: "16px",
        fontWeight: "600",
        },
    feature: {
        color: textNeutralSecondary,
        fontSize: "14px",
    }
};


export interface InvoicingPeriodInputsProps {
    hasAdjustments: boolean;
    computationFrequency?: ComputationFrequency;
    hasInvoiceDecomposition: boolean;
    onComputationFrequencyChange: (value: ComputationFrequency) => void;
    onAdjustmentFrequencyChange: (value: AdjustmentsFrequency) => void;
    onToggleInvoiceDecomposition: (isToggle: boolean) => void;
    onToggleHasAdjustments: (isToggle: boolean) => void;
    adjustmentFrequency?: AdjustmentsFrequency;
}

export const InvoicingPeriodInputs = (props: InvoicingPeriodInputsProps) => {


    return (
        <Box sx={style.wrapper}>
            <Box sx={style.container}>
                <Typography style={style.feature}>
                    Invoice Decomposition
                </Typography>
                <Box
                    data-testid="hasInvoiceDecomposition"
                >
                    <Toggle
                        onChange={(isToggle: boolean) =>
                            props.onToggleInvoiceDecomposition(isToggle)
                        }
                        isTrue={props.hasInvoiceDecomposition}
                        name={"hasInvoiceDecomposition"}
                        label={""}
                        description=""
                    />
                </Box>
            </Box>
            <Box sx={style.container}>
                <Typography style={style.feature}>
                    Has Adjustments
                </Typography>
                <Box
                    data-testid="hasAdjustments"
                >
                    <Toggle
                        onChange={(isToggle: boolean) =>
                            props.onToggleHasAdjustments(isToggle)
                        }
                        isTrue={props.hasAdjustments}
                        name={"hasAdjustments"}
                        label={""}
                        description=""
                    />
                </Box>
            </Box>
            <br/>
            <Box sx={style.container}>
            	<Box data-testid="computationFrequency">
					<FluidSelect
						isLabelStatic
						items={[
							{
								label: "Monthly",
								value: "Monthly",
							},
							{
								label: "Bi-Monthly",
                                value: "BiMonthly",
							},
                            {
                                label: "Weekly",
                                value: "Weekly",
                            },
                        
						]}
						label={"Computation Frequency"}
						name={"computationFrequency"}
                        onChange={(selectedValue: any) =>
                            props.onComputationFrequencyChange(
                                selectedValue as ComputationFrequency
                            )
                        }
						value={`${props.computationFrequency}`}
					/>
				</Box>
            	<Box data-testid="adjustmentFrequency">
					<FluidSelect
						isLabelStatic
						items={[
                        {
							label: "Bi-Monthly",
                            value: "BiMonthly",
						},
						{
							label: "Monthly",
							value: "Monthly",
						},

                        {
                            label: "Weekly",
                            value: "Weekly",
                        },
                        {
                            label: "Yearly",
                            value: "Yearly",
                        },
                        {
                            label: "Quarterly",
                            value: "Quarterly",
                        },
                        {
                            label: "Semi Annually",
                            value: "SemiAnnually",
                        },
                        {
                            label: "At Maturity",
                            value: "AtMaturity",
                        },

                        
					]}
					label={"Adjustment Frequency"}
					name={"adjustmentFrequency"}
                    onChange={(selectedValue: any) =>
                        props.onAdjustmentFrequencyChange(
                            selectedValue as AdjustmentsFrequency
                        )
                    }
					value={`${props.adjustmentFrequency}`}
				/>
				</Box>
			</Box>
        </Box>
    );
};